export const BUSINESS_PARTNER_PERMISSIONS = Object.freeze({
    READ: "business_partner:read",
    CREATE: "business_partner:create",
    UPDATE: "business_partner:update",
    ACTIVATE: "business_partner:activate",
    DEACTIVATE: "business_partner:deactivate",
});

export const DRAWER_MODES = Object.freeze({
    ADD: "add",
    EDIT: "edit",
    VIEW: "view",
});
